import { render } from "./accessDataModal.vue?vue&type=template&id=e0cf09f8&ts=true"
import script from "./accessDataModal.vue?vue&type=script&lang=ts"
export * from "./accessDataModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__